module.exports = __webpack_public_path__ + "img/user.2b508742.png";